import { useState, useEffect } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { useTranslation } from "react-i18next";
import { isMuted, setMuted } from "@/lib/sound";

export default function SoundToggle() {
  const { t } = useTranslation();
  const [muted, setLocalMuted] = useState(false);

  useEffect(() => { setLocalMuted(isMuted()); }, []);

  const toggle = () => {
    const next = !muted;
    setMuted(next);
    setLocalMuted(next);
  };

  return (
    <button
      onClick={toggle}
      className="glass rounded-full p-2 hover:border-amber-400/50 transition-colors"
      aria-label={t(muted ? "sound.unmute" : "sound.mute")}
      data-testid="sound-toggle"
      title={t(muted ? "sound.unmute" : "sound.mute")}
    >
      {muted
        ? <VolumeX className="w-4 h-4 text-stone-400" />
        : <Volume2 className="w-4 h-4 text-amber-300" />}
    </button>
  );
}
